import { Pipe, PipeTransform } from '@angular/core';
import { resourceText } from './services/localization';

@Pipe({name:'translate', standalone:true, pure:false})
export class LocalizedPipe implements PipeTransform {
  transform(key: string, params?: Record<string,string|number>) { return resourceText(key, params); }
}
